
import React from 'react';
import { motion } from 'framer-motion';
import { Progress } from '@/components/ui/progress';

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
  description: React.ReactNode;
  color: string;
}

export const StatCard = ({ icon, title, value, description, color }: StatCardProps) => {
  const getColorClass = () => {
    switch (color) {
      case 'blue': return 'bg-blue-50 text-blue-600';
      case 'green': return 'bg-green-50 text-green-600';
      case 'purple': return 'bg-purple-50 text-purple-600';
      case 'amber': return 'bg-amber-50 text-amber-600';
      default: return 'bg-primary/10 text-primary';
    }
  };

  return (
    <motion.div
      whileHover={{ y: -5 }}
      transition={{ type: "spring", stiffness: 300 }}
      className="glass-card rounded-xl p-5"
    >
      <div className="flex justify-between items-start mb-2">
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${getColorClass()}`}>
          {icon}
        </div>
      </div>
      <h3 className="text-sm font-medium text-muted-foreground mb-1">{title}</h3>
      <p className="text-2xl font-bold font-lexend">{value}</p>
      <div className="mt-1 text-sm text-muted-foreground">{description}</div>
    </motion.div>
  );
};
